export default __webpack_public_path__ + "static/media/google_sheets.bb8db9ef.png";